module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_6_2.fbfb6565.jpeg";